<template>
  <div class="modal-mask" v-show="showCategoryEditModal" transition="modal">
    <div class="modal-wrapper">
      <div class="modal-container">

        <b-tabs content-class="mt-3" fill>
          <b-tab title="Категория" active>
            <div class="form-group">
              <div class="d-flex justify-content-between">
                <label>Наименование [RU]</label>
                <span>ID: {{ categoryEdit.id }}</span>
              </div>
              <input type="text" class="form-control" v-model="categoryEdit.title" disabled/>
            </div>
            <div class="form-group">
              <label>Код</label>
              <input type="text" class="form-control" v-model="categoryEdit.code" disabled/>
            </div>
            <div class="form-group">
              <label>Дата удаления (Не обязательно)</label>
              <date-picker class="w-100" v-model="categoryEdit.delete_at" valueType="format"></date-picker>
            </div>
          </b-tab>
          <b-tab title="Язык">
            <div class="form-group">
              <label>Язык</label>
              <select class="form-control" @change="onSelectCategoryLang()" v-model="categoryEdit.language">
                <option disabled>Выберите тип</option>
                <option
                    v-if="!inArray(language.lang ,categoryEdit.translations,2)"
                    v-for="language in languages"
                    :value="language.lang"
                    :key="language.id"
                >{{ language.lang }}
                </option>
              </select>
            </div>
            <div class="form-group" v-if="categoryEdit.language != null">
              <div class="form-group">
                <label>Наименование [{{ categoryEdit.language }}]</label>
                <input type="text" class="form-control" v-model="categoryEdit[categoryEdit.language + '_title']"/>
              </div>
            </div>
          </b-tab>
          <b-tab title="Существует">
            <div v-for="translation in categoryEdit.translations" :key="translation.id">
              <p>[{{ translation.locale }}] - {{ translation.title }}</p>
            </div>
          </b-tab>
        </b-tabs>

        <div class="modal-footer" style="justify-content: space-around;">
          <slot name="footer">
            <button class="modal-button btn btn-danger" @click="updateTab('update',false)">Закрыть</button>
            <button class="modal-button btn btn-success" @click="categoryUpdate()">Изменить</button>
          </slot>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {GET, POST} from "@/shared/api";
import {funcs} from "@/_helpers/_sumple_funcs";

export default {
  props: {
    categoryEdit: {},
    showCategoryEditModal: false,
    languages: []
  },
  data() {
    return {
      categorySearch: null,
      categorySearchData: [],
    }
  },
  methods: {

    updateTab(event, state) {
      this.$emit(event, state);
    },
    onSelectCategoryLang() {
      for (let index = 0; index < this.categoryEdit.translations.length; index++) {
        if (this.categoryEdit.translations[index].locale == this.categoryEdit.language) {
          this.categoryEdit[this.categoryEdit.language + '_title'] = this.categoryEdit.translations[index].title
        }
      }
    },
    categoryUpdate(item) {
      POST(this.categoryEdit, "/categoryUpdate", this).then(response => {
        this.updateTab('update', false);
      });
    },

    changeCategoryParentId(item) {
      this.categoryEdit.parent_id = item.id
      this.$set(this.categoryEdit, 'parent_to_change', item)
      this.categorySearch = ""
      this.categorySearchData = []
    },
    findCategories() {
      if (this.categorySearch) {
        GET([], "/findCategory/" + this.categorySearch, this, false).then(response => {
          this.categorySearchData = []
          for (let i = 0; i < response.length; i++) {
            if (this.categoryEdit.id != response[i]['id']) {
              this.categorySearchData.push(response[i]);
            }
          }
          if (this.categoryEdit.parent_id) {
            this.categorySearchData.unshift({'title': 'Основная категория', 'id': 0, 'code': ""})
          }
        });
      }
    },
    inArray(lang, translations, mode) {
      if (!Array.isArray(translations)) {
        return false;
      }
      let res = [];
      let locales = [];
      if (mode === 2) {
        translations.forEach((el) => {
          locales.push(el.locale);
        });
        res = locales
      } else {
        res = translations;
      }
      return funcs.inArray(lang, res)
    }
  },
  watch: {
    categorySearch: function (newVal, oldVal) {
      if (this.categorySearch.length === 0) {
        this.categorySearchData = []
      }
    }
  },
}
</script>

<style>

</style>